import config from '@config';

export class LayoutHelper
{
    setup()
    {
        this.handleFilterArrowIcons();
    }

    /**
     * Handle the filter arrow icons on the filter menu.
     */
    handleFilterArrowIcons()
    {
        addEventListener('load', () => {
            let filterMenuClasses = ['menux', 'menuz'];

            for (let i = 0; i < filterMenuClasses.length; i++)
            {
                let filterMenus = document.querySelectorAll('.' + filterMenuClasses[i]);

                for (let j = 0; j < filterMenus.length; j++)
                {
                    let filterMenu = filterMenus[j];

                    // get the .svg-icon-filter element
                    let filterIcon = filterMenu.querySelector('.svg-icon-filter');
                    
                    if (filterIcon != null)
                    {
                        filterMenu.addEventListener('click', () => {
                            let filterIconImage = filterMenu!.classList.contains('active') ? 'chevron-down-solid.svg' : 'chevron-up-solid.svg';
                            filterIcon!.setAttribute('src', config.defaultPublicDirBaseUrl + 'template/images/svg/' + filterIconImage);
                        });
                    }
                }
            }
        });
    }
}

export default LayoutHelper;